module.exports = __webpack_public_path__ + "static/media/option-btn-tc.8929bc94.png";